const config = {
  appUrl: 'https://edge01.fleet-pulse.com',
};

export default config;
